import { toTitleCase } from "common/utils/strings";
import cx from "ui/cx";
import styles from "./SubmitButton.module.scss";

interface SubmitButtonProps extends React.HTMLProps<HTMLButtonElement> {
  secondary?: boolean;
  children: string;
}

export default function SubmitButton({ children, secondary = false, disabled, ...props }: SubmitButtonProps) {
  return (
    <button {...props} type="submit" className={cx({ styles, wrapper: true, secondary, disabled })}>
      {toTitleCase(children)}
    </button>
  );
}
